<template>
  <div class="news-list" style="flex: 1;box-sizing: border-box;">
    <!-- <div
      style="font-size: 18px;font-weight: 500; border-bottom: 1px solid #CCCCCC; padding-bottom: 16px;margin-bottom: 16px;">
      {{ L('热门文章') }}</div> -->

    <div>
      <div v-for="(item, index) in newsList" :key="index" class="item pointer" @click="toDetails(item)">
        <!-- <img :src="item.newsImage" alt="expert photo"
          style="width: 70px;height: 70px;object-fit: cover;margin-right: 16px;" /> -->
        <div style="flex: 1; display: flex;flex-direction: column;justify-content: space-between;">
          <div class="title">{{ L(item.newsTitle) }}</div>

          <div class="time">{{ item.linkMagazine ? L('摘自' + item.linkMagazine) : '' }}</div>
        </div>
      </div>
    </div>


    <!-- <More>
      <div @click="toArticle(19)">更多文章</div>
    </More> -->
  </div>
</template>

<script>
import More from './more.vue';

export default {
  components: {
    More
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      newsList: []
    }
  },
  watch: {
    list() {
      this.newsList = this.list.map((item) => {
        item.newsImage = !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage;
        return item;
      });
    }
  },
  methods: {
    toDetails(item, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        localStorage.setItem('newsId', item.newsId);
        let path = item.seoUrl ? item.seoUrl : item.newsId
        this.$router.push({
          path: `/${path}.html`,
        });
      }
    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
    toArticle(typeId) {
      this.$router.push({
        path: `/article?typeId=${typeId}`,
      });
    },
  },
}
</script>

<style scoped>
.item {
  display: flex;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E5E5EA;
}

.pointer {
  cursor: pointer;
}

.title {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 18px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: justify;
  font-style: normal;
  margin-bottom: 6px;
  border-left: 4px solid #E2291E;
  padding-left: 8px;
}

.time {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #E2291E;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  padding-left: 12px;
}

@media screen and (max-width: 768px) {
  .news-list {
    margin-top: -16px;
  }

  .item {
    padding: 16px 0;
    margin: 0;
  }

  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #2C2C2E;
    line-height: 18px;
    text-align: justify;
    font-style: normal;
  }

  .time {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #E2291E;
    line-height: 16px;
    text-align: left;
    font-style: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/expert/news.vue